import { type Ref, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import { useScrollLock } from '@vueuse/core'

export function useHeader() {
  const pageScrollTarget = ref<HTMLElement | null>(
    null,
  ) as Ref<HTMLElement | null>
  const isPageScrollLocked = useScrollLock(pageScrollTarget)
  let preventTouch: (e: TouchEvent) => void

  onMounted(() => {
    pageScrollTarget.value = document.documentElement

    preventTouch = (e: TouchEvent) => {
      if (!(e.target as HTMLElement).closest('.scrollable')) {
        e.preventDefault()
      }
    }
  })

  watch(isPageScrollLocked, (locked) => {
    if (locked) {
      document.addEventListener('touchmove', preventTouch, { passive: false })
    } else {
      document.removeEventListener('touchmove', preventTouch)
    }
  })

  onBeforeUnmount(() => {
    document.removeEventListener('touchmove', preventTouch)
  })

  return {
    pageScrollTarget,
    isPageScrollLocked,
  }
}
